export interface SeasonalSale {
  id: "halloween" | "holiday";
  promoCode: string;
  startsAt: number;
  endsAt: number;
}

// Both Stripe promo codes (HALLOWEEN20, HOLIDAY20) were created directly in
// the Stripe Dashboard with redeem_by set to Oct 31 / Dec 31 at 11:59pm in
// Jonathan's local timezone (Europe/Madrid). Spain is on CET (UTC+1) on both
// of these dates in 2026 (DST ends the last Sunday of October, the 25th), so
// the cutoffs below are anchored to that offset. If the Stripe dashboard
// account timezone is ever different, these two endsAt values need updating
// to match Stripe's actual redeem_by instant — showing the banner past that
// moment means the checkout page silently drops the "expired" promo code
// with no explanation to the customer (same failure mode as ADR-0119).
// 2026-10-19 (ADR-0171): the Halloween and holiday sales were ended early with the price rise (they did not lift orders). Keep this list empty
// to run no sitewide sale; the 7-day welcome discount (20 percent) is unaffected. To run a sale again, add an entry with its Stripe promo code.
// HALLOWEEN20 (redeem_by Oct 31) and HOLIDAY20 (redeem_by Dec 31) were: halloween 2026-09-01 to 2026-10-31 22:59:59 UTC, holiday
// 2026-10-31 23:00 UTC to 2026-12-31 22:59:59 UTC.
export const SEASONAL_SALES: SeasonalSale[] = [];

export function getActiveSeasonalSale(): SeasonalSale | null {
  const now = Date.now();
  return SEASONAL_SALES.find((sale) => now >= sale.startsAt && now <= sale.endsAt) ?? null;
}
